(() => {
  const desktopHoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const gallerySelector = '.template-search__results [data-custom-mobile-collection-gallery]';

  const getIndexButton = (gallery, index) =>
    gallery.querySelector(`[data-custom-mobile-collection-gallery-index="${index}"]`);

  const showIndex = (gallery, index) => {
    const button = getIndexButton(gallery, index);
    if (!button || Number.parseInt(gallery.dataset.galleryIndex || '0', 10) === index) return;
    button.click();
  };

  const showIndexWhenReady = (gallery, index, shouldContinue, attempt = 0) => {
    if (!shouldContinue() || attempt > 100) return;
    if (gallery.dataset.galleryAnimating === 'true') {
      window.setTimeout(() => showIndexWhenReady(gallery, index, shouldContinue, attempt + 1), 40);
      return;
    }
    showIndex(gallery, index);
  };

  document.addEventListener('pointerover', (event) => {
    if (!desktopHoverQuery.matches || !(event.target instanceof Element)) return;

    const gallery = event.target.closest(gallerySelector);
    if (!gallery || (event.relatedTarget instanceof Node && gallery.contains(event.relatedTarget))) return;

    gallery.dataset.customSearchDesktopSecondImageHover = 'true';
    showIndexWhenReady(
      gallery,
      1,
      () => desktopHoverQuery.matches && gallery.dataset.customSearchDesktopSecondImageHover === 'true'
    );
  });

  document.addEventListener('pointerout', (event) => {
    if (!(event.target instanceof Element)) return;

    const gallery = event.target.closest(gallerySelector);
    if (
      !gallery ||
      gallery.dataset.customSearchDesktopSecondImageHover !== 'true' ||
      (event.relatedTarget instanceof Node && gallery.contains(event.relatedTarget))
    ) {
      return;
    }

    delete gallery.dataset.customSearchDesktopSecondImageHover;
    showIndexWhenReady(
      gallery,
      0,
      () => desktopHoverQuery.matches && gallery.dataset.customSearchDesktopSecondImageHover !== 'true'
    );
  });
})();
